export const CARPENTER_ROOMS = [
  "Kitchen",
  "Living Room",
  "Bedroom 1",
  "Bedroom 2",
  "Bedroom 3",
  "Bedroom 4",
  "Master Bedroom",
  "Guest Bedroom",
  "Foyer",
  "Balcony",
  "Pooja",
  "Other Room 1",
  "Other Room 2",
  "Other Room 3",
];

export const CARPENTER_GROUPS = [
  "Wall A",
  "Wall B",
  "Wall C",
  "Wall D",
  "Wall E",
  "Wall F",
];

export const EXPO_SIDE_IDS = [
  "exposed_side_top",
  "exposed_side_bottom",
  "exposed_side_left",
  "exposed_side_right",
  "exposed_side_back",
];

export const UI_RESTRICTED_PROPERTIES = [
  "fabrication",
  "pre_drilling",
  "grooves",
  "assembly",
  "expo_minifix",
  "handle",
  "shutter",
  "internal_drawer_handle",
];

export const EXPO_PROPERTY_CONSTANTS = {
  top: ["exposed_side_top_true", "exposed_side_top_false"],
  bottom: ["exposed_side_bottom_true", "exposed_side_bottom_false"],
  left: ["exposed_side_left_true", "exposed_side_left_false"],
  right: ["exposed_side_right_true", "exposed_side_right_false"],
  back: ["exposed_side_back_true", "exposed_side_back_false"],
};

export const PROPERTIES_TO_HIDE = [
  "Predrilling",
  "Carcass Grooves",
  "Module Assembly",
  "Minifix for Exposed Cabinet",
  "Fabrication Quality",
];

export const PILLS = [
  "Wardrobe",
  "Kitchen Floor Unit",
  "Kitchen Wall Unit",
  "Frame Loft",
  "Open Box",
];

export const EXPO_COLOR_PROPERTIES = [
  "left_expo_color",
  "right_expo_color",
  "top_expo_color",
  "bottom_expo_color",
  "back_expo_color",
];

export const EDGE_COLOR_PROPERTIES = [
  "partition_front_edge_color",
  "carcass_front_edge_color",
];

export const LAM_CATEGORIES = [
  "lam_1",
  "lam_350_400",
  "lam_400_450",
  "lam_450_500",
  "lam_500_550",
  "lam_550_600",
  "lam_600_650",
  "lam_650_700",
  "lam_700_750",
  "lam_750_1000",
  "lam_1000_1250",
  "lam_1250_1500",
  "lam_1500_1750",
  "lam_1750_2000",
  "lam_2000_2500",
  "lam_2500_3500",
  "lam_3500_4500",
  "lam_4500_plus",
  "lam_4500_5500",
  "lam_5500_6500",
  "lam_6500_7500",
  "lam_7500_8500",
];

export const LAM_BRANDS = [
  "Acemica",
  "Acrosheen",
  "Acrylam",
  "Advance",
  "Aerolite",
  "Aica",
  "Airolam",
  "Alco",
  "Archidlam",
  "Artistry",
  "Axilam",
  "Belador",
  "Berga",
  "Brand",
  "Bravia",
  "Catch",
  "Century",
  "Ciscon",
  "Delta",
  "Dexarte",
  "Dixon",
  "Dorby",
  "Durian",
  "Encode",
  "Europratik",
  "Finetouch",
  "Flexibond",
  "Fushion",
  "Fusion",
  "Genoa",
  "Gloirio",
  "Greenlam",
  "Heritage",
  "Hilaxe",
  "I-lam",
  "Italam",
  "Manilam",
  "Matchlam",
  "Meraki",
  "Merino",
  "Merru",
  "Newmika",
  "Nisac",
  "Ogaan",
  "Pebble",
  "Promica",
  "Rehau",
  "Rgb",
  "Rotolam",
  "Royal Crown",
  "Royale Touche",
  "SK",
  "SK2",
  "Safari",
  "Safedecor",
  "Sapphire",
  "Sequence",
  "Shd",
  "Signature",
  "Skydecors",
  "Star",
  "Star Mica",
  "Stylam",
  "Sundek",
  "Sunmica",
  "Swedish",
  "Timex",
  "Toughline",
  "Treelam",
  "Urban",
  "Vibron",
  "Vir",
  "Virgo",
  "Virgolam",
  "Virlam",
  "Wolaxe",
  "Zak",
  "Zurich",
];

export const LAM_THICKNESSES = [0.6, 0.7, 0.8, 1, 1.25, 1.5, 2];

export const BASE_TYPES = [
  {
    type: "shell",
    addonsType: [
      "only_carcass",
      "shell_variant",
      "internal_color",
      "shutter_colors",
      "external_color",
      "carcass_material",
      "shutter_material",
      "hinge",
      "plinth",
      "expo",
      "expo_material",
      "minifix",
      "cnc",
      "pattern",
      "handle_type",
      "g_profile_finish",
      "j_profile_finish",
      "gola_profile_floor_finish",
      "gola_profile_wall_finish",
      "carcass_front_edge_color",
      "backsheet_build_technique",
      "drawer_mechanism",
      "shutter_type",
      "build_type",
      "carcass_thickness",
      "front_offset",
      "partition_front_edge_thickness",
      "front_edge_thickness",
      "shutter_thickness",
      "shutter_edge_thickness",
      "open_carcass_backsheet_type",
      "sliding_shutter_mechanism",
      "skirting_height",
      "frame_depth",
      "frame_carcass_type",
      "back_expo_color",
      "left_expo_color",
      "right_expo_color",
      "top_expo_color",
      "bottom_expo_color",
      "partition_front_edge_color",
      "profile_type",
      "profile_handle_type",
      "profile_color",
      "profile_glass_type",
      "profile_handle_position",
      "drawer_mechanism_type",
      "sliding_shutter_mechanism_3_door",
      "sliding_shutter_mechanism_2_door"
    ],
  },
  {
    type: "regular_drawers",
    addonsType: [
      "internal_color",
      "carcass_material",
      "shutter_material",
      "drawer_channel",
    ],
  },
  {
    type: "wide_drawers",
    addonsType: [
      "internal_color",
      "carcass_material",
      "shutter_material",
      "drawer_channel",
    ],
  },
  {
    type: "shelves",
    addonsType: [
      "internal_color",
      "shutter_colors",
      "external_color",
      "carcass_material",
      "shutter_material",
    ],
  },
];
